<h1 class="table__title">Permissions</h1>

<ul class="table__control inline-list">
  <li>
    <button matTooltip="Add User Access" *ngIf="editMode" mat-raised-button class="grey-btn" (click)="addPermission()">
      <mat-icon><img src="assets/images/icon-add.svg" /></mat-icon>
      Add Permission
    </button>
  </li>
  <li>
    <mat-form-field>
      <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Search" />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </li>
</ul>
<ng-template #noDocs>
  <h4>No Permissions</h4>
</ng-template>
<div class="table__container">
  <table *ngIf="value?.length > 0;else noDocs" class="table__inner" mat-table [dataSource]="dataSource">
    <ng-container matColumnDef="Action" *ngIf="editMode">
      <th mat-header-cell *matHeaderCellDef>Action</th>
      <td mat-cell *matCellDef="let element"><a matTooltip="Remove User Access" *ngIf="element?.direct"
          (click)="delete(element)">
          <!-- <img src="assets/images/icon-cross.svg" /> -->
          <mat-icon>delete</mat-icon>
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="Username">
      <th mat-header-cell *matHeaderCellDef>Username</th>
      <td mat-cell *matCellDef="let row;let element;">{{ element?.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="Level">
      <th mat-header-cell *matHeaderCellDef>Access Level</th>
      <td mat-cell *matCellDef="let row;let element;"><a (click)="edit(row)"
          class="permissionLink">{{ element?.level }}</a></td>
    </ng-container>

    <ng-container matColumnDef="ExpiryDate">
      <th mat-header-cell *matHeaderCellDef>Expiry Date</th>
      <td mat-cell *matCellDef="let row;let element;">{{ element?.accessExpiryDate | aspenDate}}</td>
    </ng-container>



    <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true">
    </tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" [ngClass]="{indirectRow:!row.direct}"></tr>
  </table>
  <div class="table__pagination">
    <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
  </div>
